'use client'

import { useCreditBalance } from '@/hooks/use-billing'

/**
 * App-shell credit balance hydrator.
 *
 * The actual blocking of agent turns is handled separately by
 * ``useBillingGate`` (disabled buttons) and the 402 handler. This component
 * intentionally renders no global banner, so onboarding and in-flight chat
 * turns are not interrupted by top-of-page billing chrome.
 */
export function CreditStatusBanner() {
  // Hydrate the credit store even on pages that don't render the sidebar
  // indicator. SWR dedupes by key, so this is free when the indicator has
  // already triggered the fetch.
  useCreditBalance()

  return null
}
